// -------------------------------------------------------------------------- //
// Style
// -------------------------------------------------------------------------- //

require('../scss/front.scss');

// -------------------------------------------------------------------------- //
// Javascript
// -------------------------------------------------------------------------- //

require('./config.js');
require('./vendor.js');
require('./main.js');
